import Admin from 'hive-admin';

// eslint-disable-next-line max-len
import FieldConnectionSelect from 'hive-admin/src/components/FieldConnectionSelect';

import Types from '../modules/types';

Admin.addToLibrary('FieldConnectionSelect', (config = {}) => (
  // eslint-disable-next-line max-len
  FieldConnectionSelect.create({
    getSearchTerm: (search, props) => (
        search?.length
      ? `${
          props?.searchMatchesStart ? '^' : ''
        }${
          Types.getSafeSearchRegex(search)
        }${
          props?.searchMatchesEnd ? '$' : ''
        }`
      : FieldConnectionSelect.config.getSearchTerm(search, props)
    ),
    ...config,
  })
));
